export default "__VITE_ASSET__57wkrGDt__"